import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import HomePage from './Pages/HomePage';

function App() {
  return (
    <div className="App">
     <Navbar/>
     <br/>
     <br/>
     <HomePage/>
    </div>
  );
}

export default App;
